import { render, staticRenderFns } from "./Wizzard.vue?vue&type=template&id=bfbf1f5a&scoped=true&"
var script = {}
import style0 from "./Wizzard.vue?vue&type=style&index=0&id=bfbf1f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbf1f5a",
  null
  
)

export default component.exports